import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiErrorResponse, ApiServiceInterface } from '@hutsix/ngxh6';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PasswordResetComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();

    public token: string | null = null;
    public form: { first: string | null; second: string | null } = { first: null, second: null };
    public loading = false;
    public success = false;
    public error?: string;

    constructor(
        @Inject('ApiService') private api: ApiServiceInterface,
        private route: ActivatedRoute,
        private router: Router,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.route.queryParamMap.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
            this.token = params.get('token');
            this.cdRef.detectChanges();
        });
    }

    public passwordsMatch(): boolean {
        return !!this.form.first && this.form.first === this.form.second;
    }

    public doReset(): void {
        if (!this.token || !this.passwordsMatch()) return;
        this.loading = true;
        this.error = undefined;
        this.api
            .post({
                url: '/api/user/reset-action',
                data: { token: this.token, plainPassword: { first: this.form.first, second: this.form.second } },
                skipAuth: true,
            })
            .subscribe(
                () => {
                    this.success = true;
                    this.loading = false;
                    this.cdRef.detectChanges();
                    setTimeout(() => this.router.navigate(['/login']), 2500);
                },
                (err: ApiErrorResponse<any>) => {
                    this.loading = false;
                    this.error =
                        err.error?.status === 400
                            ? 'This reset link is invalid or has expired. Please request a new one.'
                            : (err.message ?? 'Something went wrong. Please try again.');
                    this.cdRef.detectChanges();
                },
            );
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
